import { render, staticRenderFns } from "./ProfileDocumentButton.vue?vue&type=template&id=64672a4c&scoped=true&"
import script from "./ProfileDocumentButton.vue?vue&type=script&lang=js&"
export * from "./ProfileDocumentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64672a4c",
  null
  
)

export default component.exports